<template>
  <div class>
    <div class="container cstTp1">
      <div class="CompaniesGridTp2">
        <div class="row d-flex align-items-center">
          <div class="col-md-3">
            <div class="text-tp-1">BUSINESS IS BACK</div>
            <div class="text-tp-2">ONLINE</div>
            <div class="text-tp-3">Immersive Experience</div>
            <div>
              <a href="#" class="Link-Tp-1">View Feeds</a>
            </div>
          </div>
          <div class="col-md-9 Product-Res-Grid-1">
            <div>
              <div class="row Product-Res-Grid-11">
                <div class="col-md-4">
                 <div class="Company-Box-Tp-1">
                    <div class="Post-Owner-Tp-1">
                      <div>
                        <div class="Post-Det-1">
                          <div class="PostOwner-Imge">
                            <img src="@/assets/images/c11.jpg" alt="">
                          </div>
                          <div class="PostOwner-Desc">
                            <div class="PostOwner-Desc-txt">Uaect Communication</div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <a href="#" class="ProductLinkTp101">
                            <img src="@/assets/images/sld5.jpg" alt="">
                          </a>
                        </div>
                        <div class="col-md-4">
                          <a href="#" class="ProductLinkTp101">
                            <img src="@/assets/images/sld6.jpg" alt="">
                          </a>
                        </div>
                        <div class="col-md-4">
                          <a href="#" class="ProductLinkTp101">
                            <img src="@/assets/images/sld2.jpg" alt="">
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="Company-Box-Tp-1">
                    <div class="Post-Owner-Tp-1">
                      <div>
                        <div class="Post-Det-1">
                          <div class="PostOwner-Imge">
                            <img src="@/assets/images/appsub2.jpg" alt="">
                          </div>
                          <div class="PostOwner-Desc">
                            <div class="PostOwner-Desc-txt">Reebok</div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <a href="#" class="ProductLinkTp101">
                            <img src="@/assets/images/sld2.jpg" alt="">
                          </a>
                        </div>
                        <div class="col-md-4">
                          <a href="#" class="ProductLinkTp101">
                            <img src="@/assets/images/sld3.jpg" alt="">
                          </a>
                        </div>
                        <div class="col-md-4">
                          <a href="#" class="ProductLinkTp101">
                            <img src="@/assets/images/sld4.jpg" alt="">
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="Company-Box-Tp-1">
                    <div class="Post-Owner-Tp-1">
                      <div>
                        <div class="Post-Det-1">
                          <div class="PostOwner-Imge">
                            <img src="@/assets/images/car2.jpg" alt="">
                          </div>
                          <div class="PostOwner-Desc">
                            <div class="PostOwner-Desc-txt">Adidas</div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <a href="#" class="ProductLinkTp101">
                            <img src="@/assets/images/car3.jpeg" alt="">
                          </a>
                        </div>
                        <div class="col-md-4">
                          <a href="#" class="ProductLinkTp101">
                            <img src="@/assets/images/car4.jpeg" alt="">
                          </a>
                        </div>
                        <div class="col-md-4">
                          <a href="#" class="ProductLinkTp101">
                            <img src="@/assets/images/car7.jpeg" alt="">
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                 <div class="Company-Box-Tp-1">
                    <div class="Post-Owner-Tp-1">
                      <div>
                        <div class="Post-Det-1">
                          <div class="PostOwner-Imge">
                            <img src="@/assets/images/c11.jpg" alt="">
                          </div>
                          <div class="PostOwner-Desc">
                            <div class="PostOwner-Desc-txt">Uaect Communication</div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <a href="#" class="ProductLinkTp101">
                            <img src="@/assets/images/dm-banner1.jpg" alt="">
                          </a>
                        </div>
                        <div class="col-md-4">
                          <a href="#" class="ProductLinkTp101">
                            <img src="@/assets/images/dm-banner2.jpg" alt="">
                          </a>
                        </div>
                        <div class="col-md-4">
                          <a href="#" class="ProductLinkTp101">
                            <img src="@/assets/images/grd2.jpg" alt="">
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="Company-Box-Tp-1">
                    <div class="Post-Owner-Tp-1">
                      <div>
                        <div class="Post-Det-1">
                          <div class="PostOwner-Imge">
                            <img src="@/assets/images/sld6.jpg" alt="">
                          </div>
                          <div class="PostOwner-Desc">
                            <div class="PostOwner-Desc-txt">Business Id Communication</div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <a href="#" class="ProductLinkTp101">
                            <img src="@/assets/images/dm-banner1.jpg" alt="">
                          </a>
                        </div>
                        <div class="col-md-4">
                          <a href="#" class="ProductLinkTp101">
                            <img src="@/assets/images/dm-banner2.jpg" alt="">
                          </a>
                        </div>
                        <div class="col-md-4">
                          <a href="#" class="ProductLinkTp101">
                            <img src="@/assets/images/grd2.jpg" alt="">
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="Company-Box-Tp-1">
                    <div class="Post-Owner-Tp-1">
                      <div>
                        <div class="Post-Det-1">
                          <div class="PostOwner-Imge">
                            <img src="@/assets/images/car2.jpg" alt="">
                          </div>
                          <div class="PostOwner-Desc">
                            <div class="PostOwner-Desc-txt">Adidas</div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <a href="#" class="ProductLinkTp101">
                            <img src="@/assets/images/car3.jpeg" alt="">
                          </a>
                        </div>
                        <div class="col-md-4">
                          <a href="#" class="ProductLinkTp101">
                            <img src="@/assets/images/car4.jpeg" alt="">
                          </a>
                        </div>
                        <div class="col-md-4">
                          <a href="#" class="ProductLinkTp101">
                            <img src="@/assets/images/car7.jpeg" alt="">
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Carousel3d, Slide } from "vue-carousel-3d";
export default {
  name: "updateBoxTyp1",
  components: {
    Carousel3d,
    Slide
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/homePage/updateBoxTyp1.vue